import { Tag } from 'foundations-components/transitional/components/Tag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ACCESS_TYPE_TAG_CONTENT = {
  PERSONAL: {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installedBy.description.tag.personal"
    }),
    use: 'purple'
  },
  SHARED: {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installedBy.description.tag.shared"
    }),
    use: 'info'
  }
};
export function AccessTypeTag({
  accessType
}) {
  const tagConfig = ACCESS_TYPE_TAG_CONTENT[accessType];
  if (!tagConfig) {
    return null;
  }
  const {
    message,
    use
  } = tagConfig;
  return /*#__PURE__*/_jsx(Tag, {
    use: use,
    children: message
  });
}